import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { useFormTcfVendor, useI18n } from "../../../../contexts";
import { FormHeadline } from "../../headline";
import { FormLayoutTcfVendor } from "..";
import { Form, Select, Switch, Table, Tag, Tooltip } from "antd";
import { getTcfDataRetentionTimeForPurpose } from "@devowl-wp/react-cookie-banner";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Column } = Table;
const TABLE_FORM_ITEM_PROPS = {
    labelCol: {
        span: 0
    },
    wrapperCol: {
        span: 24
    },
    style: {
        margin: 0
    }
};
const FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH = 250;
const FormTcfVendorFieldPurposes = ()=>{
    const { __, _i, _n } = useI18n();
    const { vendor, declarations: { purposes, specialPurposes } } = useFormTcfVendor();
    const { dataRetention } = vendor;
    const usePurposes = useMemo(()=>Object.values(purposes).map((purpose)=>vendor.purposes.indexOf(purpose.id) > -1 || vendor.legIntPurposes.indexOf(purpose.id) > -1 ? {
                purpose,
                type: "normal"
            } : undefined).concat(Object.values(specialPurposes).map((specialPurpose)=>vendor.specialPurposes.indexOf(specialPurpose.id) > -1 ? {
                purpose: specialPurpose,
                type: "special"
            } : undefined)).filter(Boolean), [
        vendor,
        purposes,
        specialPurposes
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormLayoutTcfVendor.labelCol.span,
                description: _i(__('The vendor specifies for which defined purposes he wants to process (personal) data of your visitors and use cookies. These can be deselected if consent should not be obtained for certain purposes. The vendor specifies the legal basis for data processing in according to  {{aGdpr}}Art. 6 GDPR{{/aGdpr}} and whether you as the website operator can change this. "Legitimate Interest" means that this purpose is pre-selected on the basis of a legally designated legitimate interest, and the visitor to your website must actively object to it, if an objection is possible. "Consent" means that your visitors must explicitly agree to this purpose. The default settings are provided by the vendor, but do not have to match how you use the vendor on your website. In particular, you may need to make adjustments, if possible, in the "Legal basis" column. {{strong}}A legitimate interest exists only in a very few cases. If you are not sure, it is better to obtain consent.{{/strong}}'), {
                    strong: /*#__PURE__*/ _jsx("strong", {}),
                    aGdpr: /*#__PURE__*/ _jsx("a", {
                        href: __("https://gdpr-text.com/read/article-6/"),
                        target: "_blank",
                        rel: "noreferrer"
                    })
                }),
                children: __("Purposes and special purposes")
            }),
            /*#__PURE__*/ _jsxs(Table, {
                dataSource: usePurposes,
                rowKey: (param)=>{
                    let { purpose: { id }, type } = param;
                    return `${type}${id}`;
                },
                size: "small",
                bordered: true,
                pagination: false,
                style: {
                    marginBottom: 25
                },
                children: [
                    /*#__PURE__*/ _jsx(Column, {
                        width: FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH,
                        title: __("Name"),
                        dataIndex: "name",
                        render: (_, param)=>{
                            let { purpose: { name } } = param;
                            return name;
                        }
                    }, "name"),
                    /*#__PURE__*/ _jsx(Column, {
                        title: __("Enabled"),
                        dataIndex: "enabled",
                        render: (_, param)=>{
                            let { purpose: { id }, type } = param;
                            return /*#__PURE__*/ _jsx(Form.Item, {
                                ...TABLE_FORM_ITEM_PROPS,
                                name: type === "special" ? undefined : [
                                    "restrictivePurposes",
                                    type,
                                    id.toString(),
                                    "enabled"
                                ],
                                valuePropName: "checked",
                                children: /*#__PURE__*/ _jsx(Switch, {
                                    size: "small",
                                    disabled: type !== "normal",
                                    defaultChecked: type === "special" ? true : undefined
                                })
                            });
                        }
                    }, "enabled"),
                    /*#__PURE__*/ _jsx(Column, {
                        title: __("Legal basis"),
                        dataIndex: "name",
                        render: (_, param)=>{
                            let { purpose: { id }, type } = param;
                            return /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                shouldUpdate: (prevValues, nextValues)=>{
                                    var _prevValues_restrictivePurposes_type, _nextValues_restrictivePurposes_type;
                                    return ((_prevValues_restrictivePurposes_type = prevValues.restrictivePurposes[type]) == null ? void 0 : _prevValues_restrictivePurposes_type[id].enabled) !== ((_nextValues_restrictivePurposes_type = nextValues.restrictivePurposes[type]) == null ? void 0 : _nextValues_restrictivePurposes_type[id].enabled);
                                },
                                children: (param)=>{
                                    let { getFieldValue } = param;
                                    return /*#__PURE__*/ _jsx(Form.Item, {
                                        ...TABLE_FORM_ITEM_PROPS,
                                        name: type === "special" ? undefined : [
                                            "restrictivePurposes",
                                            type,
                                            id.toString(),
                                            "legInt"
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Select, {
                                            size: "small",
                                            disabled: vendor.flexiblePurposes.indexOf(id) === -1 || !getFieldValue([
                                                "restrictivePurposes",
                                                type,
                                                id.toString(),
                                                "enabled"
                                            ]),
                                            defaultValue: type === "special" ? "no" : undefined,
                                            children: [
                                                /*#__PURE__*/ _jsx(Select.Option, {
                                                    value: "yes",
                                                    children: __("Legitimate interest")
                                                }),
                                                /*#__PURE__*/ _jsx(Select.Option, {
                                                    value: "no",
                                                    children: __("Consent")
                                                })
                                            ]
                                        })
                                    });
                                }
                            });
                        }
                    }, "name"),
                    /*#__PURE__*/ _jsx(Column, {
                        title: __("Description"),
                        dataIndex: "description",
                        render: (_, param)=>{
                            let { purpose: { description, illustrations }, type } = param;
                            return /*#__PURE__*/ _jsxs(Tooltip, {
                                title: illustrations.length > 0 && /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("strong", {
                                            children: [
                                                __("Illustrations"),
                                                ": "
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            children: illustrations.map((illustration)=>/*#__PURE__*/ _jsx("li", {
                                                    children: illustration
                                                }, illustration))
                                        })
                                    ]
                                }),
                                placement: "bottomLeft",
                                overlayInnerStyle: {
                                    width: 500
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(InfoCircleOutlined, {
                                        style: {
                                            cursor: "pointer",
                                            opacity: 0.5
                                        }
                                    }),
                                    "\xa0",
                                    description,
                                    " ",
                                    type === "special" && /*#__PURE__*/ _jsx(Tag, {
                                        color: "warning",
                                        children: __("Special purpose")
                                    })
                                ]
                            });
                        }
                    }, "description"),
                    /*#__PURE__*/ _jsx(Column, {
                        title: __("Data retention period"),
                        dataIndex: "dataRetention",
                        render: (_, param)=>{
                            let { purpose: { id }, type } = param;
                            const days = getTcfDataRetentionTimeForPurpose(dataRetention, id, type === "special");
                            return days ? _n("%d day", "%d days", days, days) : __("Not defined");
                        }
                    }, "dataRetention")
                ]
            })
        ]
    });
};
export { FormTcfVendorFieldPurposes, FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH };
